import React, { useState, useEffect, useRef, useContext } from "react";
import PitchItem from "./PitchItem";
import { PitchContext } from "../context/PitchContex";

const BestPitches = () => {
  const { pitches } = useContext(PitchContext);
  const [bestPitches, setBestPitches] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const carouselRef = useRef(null);
  const intervalRef = useRef(null);

  const getBestPitches = () => {
    const bests = pitches.filter((item) => item.bestSeller);
    // Duplicate the array for infinite scroll effect
    setBestPitches([...bests, ...bests]);
  };

  useEffect(() => {
    getBestPitches();
  }, [pitches]);

  useEffect(() => {
    // Start the interval
    intervalRef.current = setInterval(() => {
      if (!isHovered) {
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }
    }, 3000);

    return () => clearInterval(intervalRef.current);
  }, [isHovered]);

  useEffect(() => {
    if (carouselRef.current && bestPitches.length > 0) {
      const itemWidth = 320;
      const totalItems = pitches.filter((item) => item.bestSeller).length; // Original length
      const scrollPosition = currentIndex * itemWidth;

      carouselRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });

      // When reaching the end of first set, instantly jump to same item in second set
      if (currentIndex === totalItems) {
        setTimeout(() => {
          carouselRef.current.scrollTo({
            left: 0,
            behavior: "instant",
          });
          setCurrentIndex(0);
        }, 500); // Match this with your CSS transition duration
      }
    }
  }, [currentIndex, bestPitches.length, pitches]);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <section className="py-8 w-full rounded-lg">
      <h2
        aria-label="Premium Halısahalar"
        className="text-3xl font-bold text-center mb-8 text-gray-800"
      >
        Premium Halısahalarımız
      </h2>
      <div
        ref={carouselRef}
        className="flex overflow-x-hidden sm:gap-4 pb-4 snap-x snap-mandatory"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ scrollBehavior: "smooth" }}
      >
        {bestPitches.map((item, index) => (
          <article
            key={`${item.id}-${index}`}
            className="min-w-[320px] snap-start scale-85 sm:scale-100"
          >
            <PitchItem
              id={item._id}
              name={item.name}
              slug={item.slug}
              location={`${item.location.city}`}
              price={item.price}
              status={item.status}
              rating={4.8}
              bestSeller={item.bestSeller}
              image={item.images[0]}
            />
          </article>
        ))}
      </div>
      <div className="flex justify-center gap-2 mt-4">
        {bestPitches.slice(0, bestPitches.length / 2).map((_, index) => (
          <span
            key={index}
            className={`w-3 h-3 rounded-full cursor-pointer transition-colors ${
              index === currentIndex % (bestPitches.length / 2)
                ? "bg-[#4d9041]"
                : "bg-gray-300 hover:bg-[#6ca845]"
            }`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default BestPitches;
